<script setup>
import CanvasTemplate from '@/components/templates/CanvasTemplate.vue';
import levenshtein from 'js-levenshtein';
import { ref } from 'vue';

let questions = [
  { word: "Die prachtvolle Gouvernante verließ prompt das großzügige Quartier und äußerte überrascht, sie müsse unverzüglich abfahren.", audio: "/audio/die_maus.mp3", result: null },
  { word: "das Licht", audio: "/audio/das_licht.mp3", result: null },
  // { word: "das Rennen", audio: "/audio/das_rennen.mp3", result: null },
  // { word: "der Lehrer", audio: "/audio/der_lehrer.mp3", result: null },
  // { word: "die Vögel", audio: "/audio/die_voegel.mp3", result: null },
  // { word: "das Geheimnis", audio: "/audio/das_geheimnis.mp3", result: null },
  // { word: "die Atmosphäre", audio: "/audio/die_atmosphaere.mp3", result: null },
  // { word: "die Konsequenz", audio: "/audio/die_konsequenz.mp3", result: null },
  // { word: "ich gehe spazieren", audio: "/audio/ich_gehe_spazieren.mp3", result: null },
  // { word: "Wir haben uns schließlich geeinigt.", audio: "/audio/wir_haben_uns_schliesslich_geeinigt.mp3", result: null },
];

const showOverlay = ref(false)
const showResult = ref(false)


let question_index = ref(0)
let question = ref(questions[0]);

const handleDoneClicked = () => {
  showOverlay.value = true
}

const handleResult = (r) => {
  const distance = levenshtein(r, question.value.word)

  questions[question_index.value].result = {
    text: r,
    distance: distance
  };

  if (question_index.value >= questions.length -1) {
    showResult.value = true
    showOverlay.value = false
    return
  }

  question_index.value = question_index.value + 1;
  question.value = questions[question_index.value]

  showOverlay.value = false
}



</script>

<template>
  <CanvasTemplate :question="question" @result="handleResult" @done="handleDoneClicked" :key="question_index" />
  <div class="overlay" v-if="showOverlay">
    Lade nächstes Word ...
  </div>

  <div class="result" v-if="showResult">
    <div class="modal">
      <div class="result_word" v-for="q in questions" :key="q">
        <span v-if="q.result && q.result.distance < 1">🟢</span>
        <span v-if="q.result && q.result.distance == 1">🟠</span>
        <span v-if="q.result && q.result.distance > 1">🔴</span>
        <span v-if="q.result == null">🔵</span>

        {{ q.word }}
        <span v-if="q.result">
          Deine Antwort:
          {{ q.result.text }}
        </span>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 40px;
  color: #fff;
}

.result {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 40px;
  color: #fff;

  .modal {
    width: 50vw;
    height: 50vh;

    background-color: #fff;

    .result_word {
      font-size: 14px;
      color: #000;
    }
  }
}

.question {
  width: 100%;
  height: 100%;
  border: solid 1px red;
  display: flex;
  flex-direction: column;
}

.word {
  height: 100%;
  font-size: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.6);
}
</style>
